import {FileField, FileInput, FormWithRedirect,} from "react-admin";
import {ReferenceInputBank} from "../../components/reference-inputs/ReferenceInputBank";
import {initInput} from "../../shared/utils";
import {FormProps} from "../../shared/types";
import {CustomToolbar} from "../../components/CustomToolbar";
import {Card, CardContent} from "@material-ui/core";


export const ReconciliationFileForm = (props: FormProps) => {
    return  (
      <FormWithRedirect
      {...props}
      render={(formProps) => (
        <Card>
          <form>
            <CardContent>
              <FileInput
                  {...initInput("file", props.fieldOptions, props.canEdit)}
                >
                  <FileField source="src" title="title" />
              </FileInput>
              <ReferenceInputBank {...initInput("bank_id", props.fieldOptions)} reference="bank"/>
              <CustomToolbar
                canEdit={props.canEdit}
                canDelete={props.canDelete}
                resource={props.resource}
                pristine={formProps.pristine}
                record={formProps.record}
                mutationMode={props.mutationMode}
                invalid={formProps.invalid}
                handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
                handleSubmit={formProps.handleSubmit}
                saving={formProps.saving}
                basePath={props.basePath}
              />
            </CardContent>
          </form>
        </Card>
        )} />
    );
}